<template>
  <component :is="mediaQueries.mobile ? 'TransitionExpand' : 'div'">
    <SectionBox v-if="mediaQueries.mobile ? collapsed : false">
      <BasicSection>
        <WithAvatarAside
          :image="user.avatar.image"
          :href="user.href"
          size="medium-large"
          roundness="full"
        >
          <SectionGroup gap="small">
            <BasicLink :href="user.href" appearance="dark">
              <PageTitle :title="user.title" />
            </BasicLink>
            <BasicText v-if="user.specialization">
              {{ user.specialization.title }}
            </BasicText>
            <div>
              <BasicButton
                appearance="tertiary"
                size="sm"
                @click="collapsed = false"
              >
                Показать ещё
              </BasicButton>
            </div>
          </SectionGroup>
        </WithAvatarAside>
      </BasicSection>
    </SectionBox>
    <UserPageSidebar v-else :user="currentUser" @openContacts="openContacts" />
  </component>
</template>

<script>
import { showErrorNotification } from 'src/services/api.js';
import { PersonalResource } from 'src/services/personal.js';

import BasicButton from 'src/components/BasicButton/BasicButton.vue';
import BasicLink from 'src/components/BasicLink/BasicLink.vue';
import PageTitle from 'src/components/PageTitle/PageTitle.vue';
import SectionBox from 'src/components/SectionBox/SectionBox.vue';
import BasicSection from 'src/components/sections/BasicSection/BasicSection.vue';
import SectionGroup from 'src/components/sections/SectionGroup/SectionGroup.vue';
import BasicText from 'src/components/text/BasicText/BasicText.vue';
import TransitionExpand from 'src/components/transitions/TransitionExpand/TransitionExpand.vue';
import UserPageSidebar from 'src/components/users/UserPageSidebar/UserPageSidebar.vue';
import WithAvatarAside from 'src/components/WithAvatarAside/WithAvatarAside.vue';

export default {
  name: 'ResponsiveUserPageSidebar',
  components: {
    BasicLink,
    WithAvatarAside,
    TransitionExpand,
    SectionGroup,
    BasicText,
    BasicButton,
    PageTitle,
    UserPageSidebar,
    BasicSection,
    SectionBox,
  },
  inject: ['mediaQueries'],
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  provide() {
    return {
      contactsConditions: this.user.contacts
        ? this.user.contacts.conditions
        : null,
      getContactsIsLoading: () => this.contactsIsLoading,
    };
  },
  data() {
    return {
      currentUser: this.user,
      contactsIsLoading: false,
      collapsed: true,
    };
  },
  methods: {
    async openContacts() {
      this.contactsIsLoading = true;
      try {
        const response = await PersonalResource.getUserContacts(this.user.id);
        this.currentUser.contacts = response.data.contacts;
        if (this.currentUser.jobInviteButton?.showHint) {
          this.currentUser.jobInviteButton.showHint = false;
        }
      } catch (error) {
        showErrorNotification(error);
      } finally {
        this.contactsIsLoading = false;
      }
    },
  },
};
</script>
